import ReactDOM from 'react-dom';
import cx from 'classnames';
import cs from './index.module.scss';
import { observer } from 'mobx-react-lite';
import { useNotifyContext } from './hooks';

const CardsContainer = ({
  children,
  className,
  parent = document.body,
  ...props
}, ref) => {
  const { isSpot } = useNotifyContext();

  return ReactDOM.createPortal(
    (
      <div ref={ref} {...props} className={cx(cs.cardsContainer, isSpot ? cs.spotStyle : '', className)}>{children}</div>
    ),
    parent,
  );
};

export default observer(CardsContainer, { forwardRef: true, });
